(() => {
  const script = document.querySelector('script[src*="croco-site-improvements.js"]');
  const config = script?.dataset || {};
  function publish(name, detail = {}) {
    if (config.trackEvents !== 'true') return;
    // Event details deliberately contain no customer names, email addresses or phone numbers.
    try { window.Shopify?.analytics?.publish?.(name, detail); } catch (_) {}
    document.dispatchEvent(new CustomEvent(name, {detail}));
  }
  function initFinders() {
    document.querySelectorAll('[data-croco-family-finder]').forEach(finder => {
      if (finder.dataset.initialized) return;
      finder.dataset.initialized = 'true';
      const input = finder.querySelector('[data-croco-family-search]');
      const results = finder.querySelector('[data-croco-family-results]');
      const status = finder.querySelector('[data-croco-family-count]');
      const items = [...results.children];
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase();
        results.hidden = !query;
        let matches = 0;
        items.forEach(item => { item.hidden = !item.textContent.toLocaleLowerCase().includes(query); if (!item.hidden) matches++; });
        status.textContent = query ? (matches ? `${matches} ${matches === 1 ? 'family' : 'families'} found` : 'No matching family. Try another name.') : '';
      });
    });
  }
  function mountLanguage() {
    if (config.headerLanguage !== 'true') return;
    const slot = document.querySelector('[data-croco-language-slot]');
    if (!slot) return;
    let widget;
    try { widget = document.querySelector(config.languageSelector || '#gt_float_wrapper, .gtranslate_wrapper'); } catch (_) { return; }
    if (!widget || widget === slot || widget.contains(slot)) return;
    widget.setAttribute('data-croco-language-widget', '');
    if (widget.parentElement !== slot) slot.appendChild(widget);
    const native = document.getElementById('HeaderLanguageForm')?.closest('localization-form');
    if (native) native.hidden = true;
  }
  function successEvents() {
    document.querySelectorAll('[data-croco-newsletter-success], [data-croco-enquiry-success]').forEach(el => {
      if (el.dataset.eventSent) return;
      el.dataset.eventSent = 'true';
      const type = el.hasAttribute('data-croco-newsletter-success') ? 'croco_newsletter_subscribed' : 'croco_enquiry_submitted';
      const key = `croco-success:${type}:${location.pathname}:${location.search}`;
      try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, '1'); } catch (_) {}
      publish(type, {source: type === 'croco_newsletter_subscribed' ? 'footer' : 'enquiry'});
    });
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (link?.classList.contains('catalogue-btn') || (link && /catalogue/i.test(link.textContent) && /catalogue|\.pdf/i.test(link.getAttribute('href') || ''))) {
      publish('croco_catalogue_clicked', {source:link.closest('footer') ? 'footer':'header'});
    }
    if (event.target.closest('#trigger-enquiry, .trigger-enquiry')) publish('croco_enquiry_opened', {source:event.target.closest('header') ? 'header':'product'});
  });
  document.addEventListener('submit', event => {
    if (event.target.closest('.croco-footer')) publish('croco_newsletter_submit_attempt', {source:'footer'});
    if (event.target.closest('.enquiry-modal')) publish('croco_enquiry_submit_attempt', {source:'enquiry'});
  });
  function init() { initFinders(); mountLanguage(); successEvents(); }
  init();
  document.addEventListener('shopify:section:load', init);
  // Translation apps can render after the theme. Watch only until a widget is mounted.
  const observer = new MutationObserver(() => { mountLanguage(); if (document.querySelector('[data-croco-language-slot] [data-croco-language-widget]')) observer.disconnect(); });
  if (config.headerLanguage === 'true') observer.observe(document.body, {childList:true,subtree:true});
})();
